{
  "title": "Мої діти",
  "description": "Як ваші діти виконують домашні завдання.",
  "empty": "У цій школі до вашого облікового запису ще не привʼязано жодної дитини.",
  "noSubmissions": "Робіт ще не здавали.",
  "loadFailed": "Не вдалося завантажити домашні завдання ваших дітей.",
  "columns": {
    "homework": "Завдання",
    "due": "Термін",
    "status": "Статус",
    "score": "Бали"
  },
  "due": "До {{date}}",
  "noDue": "Без терміну",
  "score": "{{score}} / {{max}}",
  "notGraded": "—",
  "feedback": "Коментар учителя",
  "privacyNote": "Ви бачите роботи лише власних дітей.",
  "viewProgress": "Переглянути прогрес"
}
